import createAction from '@clearscore/helpers.create-action';

import {
    TRACK_RESOLVE_FAQ_OPEN,
    TRACK_RESOLVE_FAQ_LINK_CLICKED,
    TRACK_RESOLVE_OPTION_CLICKED,
    TRACK_RESOLVE_OPTION_CTA_CLICKED,
    TRACK_RESOLVE_VIEW_ALL_MISSED_PAYMENTS_CLICKED,
    TRACK_RESOLVE_COACHING_CTA_CLICKED,
    TRACK_RESOLVE_HELP_ARTICLE_CLICKED,
    TRACK_RESOLVE_SPINNER_SHOWN,
    TRACK_RESOLVE_LANDING_SCREEN_CTA_CLICKED,
} from '../types';

const track = (type) => (context) => createAction(type, context);

export const trackFaqOpen = track(TRACK_RESOLVE_FAQ_OPEN);
export const trackFaqLinkClicked = track(TRACK_RESOLVE_FAQ_LINK_CLICKED);
export const trackOptionClicked = track(TRACK_RESOLVE_OPTION_CLICKED);
export const trackOptionCtaClicked = track(TRACK_RESOLVE_OPTION_CTA_CLICKED);
export const trackViewALLMissedPaymentsClicked = track(TRACK_RESOLVE_VIEW_ALL_MISSED_PAYMENTS_CLICKED);
export const trackCoachingCtaClicked = track(TRACK_RESOLVE_COACHING_CTA_CLICKED);
export const trackHelpArticleClicked = track(TRACK_RESOLVE_HELP_ARTICLE_CLICKED);
export const trackSpinnerShown = track(TRACK_RESOLVE_SPINNER_SHOWN);
export const trackLandingScreenCtaClicked = track(TRACK_RESOLVE_LANDING_SCREEN_CTA_CLICKED);
